import React, {Component} from 'react';
import LoadingSpinner from "../Utils/LoadingSpinner";


class PaymentByAliPay extends Component {
    state = {
        loading: true, // will be true when ajax request is running
        redirect_url: null,
        success: null,
    };

    componentDidMount() {

        this.props.simGps.getAliPayRedirectUrl(this.props.dev_uuid, this.props.amount,
            (success, result) => {
                const redirect_url = result.redirect_url;
                this.setState(
                    {
                        loading: false,
                        redirect_url: redirect_url,
                        success: success,
                    }
                )
            }
        );
    }

    render() {
        if( this.state.loading ) {
            return (<LoadingSpinner text="Preparing Alipay link ..."/>);
        } else {
            if (this.state.success ){
                return (
                    <div>
                        <a href={this.state.redirect_url} > Click here to make AliPay payment</a>
                    </div>
                )
            } else {
                return (<div> Payment failed </div>)
            }
        }
    }
}

export default PaymentByAliPay;
